export const data = [
  {
    id: 1,
    provider: "Head Of Bone And Joints",
    Description: "N/A",
    user: "--",
    userDesc: "--",
    status: "Active Studio",
    created: "Apr 29, 2024 05:06 PM",
  },
  {
    id: 2,
    provider: "HOD",
    Description: "Head Of The Department",
    user: "--",
    status: "Practitioner",
    created: "Mar 22, 2024 05:38 PM",
  },
  {
    id: 3,
    provider: "Studio",
    Description: "Studio  ",
    user: "Mohan",
    userDesc: "mohan+care.provider+6@unify.digital",
    status: "Admin",
    created: "Mar 22, 2024 05:38 PM",
  },
  {
    id: 4,
    provider: "Doctor",
    Description: "Doctor",
    user: "Dora Sai Teja",
    userDesc: "mohan+care.provider+6@unify.digital",
    status: "N/A",
    created: "Mar 14, 2024 12:34 PM",
  },
  {
    id: 5,
    provider: "Nurse",
    Description: "Nurse",
    user: "--",
    status: "Practitioner",
    created: "Mar 14, 2024 12:34 PM",
  },
];

export const rolesForm = [
  {
    type: "text",
    label: "Name*",
    id: "Name",
    placeholder: "Category Name",
  },
  {
    type: "text",
    label: "Description*",
    id: "description",
    placeholder: "Description",
  },
];
